import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Outlet } from 'react-router-dom';

export default function Nosotros() {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/nosotros/quienes-somos')        
    }, []);

    return (
        <div>
            <Outlet />    
        </div>
    )
}